// Filename: public/helper.js 
//
// Code written in public files is shared by your site's
// Backend, page code, and site code environments.
//
// Use public files to hold utility functions that can 
// be called from multiple locations in your site's code.

export const questions = ['baloons', 'parrot', 'ufo', 'colors', 'howwasit', 'sports', 'bombay', 'click', 'jack', 'brain']
let questionsData = []

import wixData from 'wix-data';
import {local} from 'wix-storage';
import moment from 'moment'
import wixLocation from 'wix-location';

export async function loadQuestionsData(){
    let results = await wixData.query("eng").find()
    questionsData = results.items;
}

export function findTitle(items, title) {    
    let correctTitle
	items.forEach(item => {
        if (item.title === title){
            correctTitle = item
        }
    });
    console.log(correctTitle)
    return correctTitle
}

export function findQuestion(title){
    let correctQuestion
	questionsData.forEach(item => {
        if (item.title === title){
            correctQuestion = item
        }
    });
    return correctQuestion
}

export function updateCluesInTeamsCollection(numOfClues){
    const teamName = local.getItem('teamName')
    wixData.query("EngTeams")
    .eq("teamName", teamName)
    .find()
    .then( (results) => {
        if(results.items.length > 0) {
        let item = results.items[0];
        item.usedClues = numOfClues

        wixData.update("EngTeams", item)
	    .then( (results) => {
		    let result = results; //see item below
	    } )
	    .catch( (err) => {
	    	let errorMsg = err;
            console.log(errorMsg)
	    } );
        }
    })
}

export async function setValueInTeamsCollection(obj, value){

    const teamName = local.getItem('teamName')
    const results = await wixData.query("EngTeams").eq("teamName", teamName).find()
    
    if(results.items.length > 0) {
        let item = results.items[0];
        item[obj] = value

        await wixData.update("EngTeams", item) 
    }   
}

export async function getValueFromTeamsCollection(obj) {

    const teamName = local.getItem('teamName')
    const results = await wixData.query('EngTeams').eq('teamName',teamName).find()

    if(results.items.length > 0){
        let item = results.items[0]
        return item[obj]
    }
}

export async function initializeTeamInCollection (teamName){
    questions.forEach(question => {
        local.setItem(question, 'false')
    })
    let dateInMili = Date.now()
    let date = moment(dateInMili).format('MMMM Do YYYY, HH:mm:ss')
    let toInsert = {
        teamName: teamName,
        startTime: date,
        startTimeMili: dateInMili,
        usedClues: 0,
        solvedQuestions: 0
    };
    try{
        await wixData.insert("EngTeams", toInsert, {suppressAuth: true})
        local.setItem('teamName', toInsert.teamName)
        local.setItem('startTime', dateInMili)
        local.setItem('usedClues', toInsert.usedClues)
        local.setItem('solvedQuestions', toInsert.solvedQuestions)
        wixLocation.to('/maineng')
    } catch(err) {
        console.log(err)
    }    
}

export async function endGame(){
    let dateInMili = Date.now()
    let date = moment(dateInMili).format('MMMM Do YYYY, HH:mm:ss')
    const teamName = local.getItem('teamName')
    let results = await wixData.query("EngTeams").eq("teamName", teamName).find()
    let item = results.items[0]
    item.endTime = date
    //item.elapsedTime = moment(moment(dateInMili).diff(item.startTime)).format("mm:ss")
    item.elapsedTime = moment(dateInMili - item.startTimeMili).format('mm:ss')
    await wixData.update('EngTeams', item)    
}

export async function correctAnswer(qName){
    local.setItem(qName, 'true')
    let solvedQuestions = await getValueFromTeamsCollection('solvedQuestions')
    await setValueInTeamsCollection('solvedQuestions', solvedQuestions+1)
}

export function getElapsedTime () {
    let startTimeMili = local.getItem('startTime')
    let elapsedMili = Date.now() - parseInt(startTimeMili)
//   return moment(elapsedMili).fomat('mm:ss')
    let seconds = parseInt(elapsedMili % (1000*60) / 1000)
    if (seconds < 10){
        seconds = '0'+seconds
    }
    return parseInt(elapsedMili / (1000*60))+":"+seconds
}



// The following code demonstrates how to call the add
// function from your site's page code or site code.

/* 
import {add} from 'public/helper.js'

$w.onReady(function () {	
    let sum = add(6,7);
    console.log(sum);
});
*/